import { render } from "./invoice.vue?vue&type=template&id=57d61ccc&scoped=true&xmlns%3Astyle=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"

import "./invoice.vue?vue&type=style&index=0&id=57d61ccc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57d61ccc"

export default script